const getClassName = (classNameMap, defaultClassName) => {
  return (classNameKey) => {
    let className = classNameMap[classNameKey]
    return className ? className : defaultClassName
  } 
}

export default getClassName